module.exports = __webpack_public_path__ + "static/media/thankYouPage.db11f815.svg";